module.exports = __webpack_public_path__ + "static/media/1POLICY15.652b24b4.jpg";